export default "__VITE_ASSET__3c3f6a6f__"